'use client';

import { Chips } from '@portals/ui-kit';
import classNames from 'classnames/bind';
import { useTranslations } from 'next-intl';
import { useLocalStorage } from '@portals/external-services-header/lib/_hooks/use-local-storage';
import { navigateHandle } from '@/_utils/navigate-handle';
import { EAnalytics } from '@/_constants/analytics';
import { useAnalytics } from '@/_hooks/use-analytics';
import { EBlocksNames } from '@/_types';
import { getUrlParams } from '../custom-header/_utils/get-url-locale-params';
import { THeaderConfig } from '../custom-header/_types';
import styles from './index.module.scss';

const cn = classNames.bind(styles);
const BLOCK_NAME = 'TempNavButtons';

type TProps = {
  links: THeaderConfig['headerLinks'];
};

export const TempNavButtons = ({ links }: TProps) => {
  const translations = useTranslations();
  const sendEvent = useAnalytics();
  const { locale } = getUrlParams();
  const { mobileWebView } = useLocalStorage();

  const handleLinkClick = (routeName: string, id: EBlocksNames) => () => {
    sendEvent({
      name: EAnalytics.SUPPLIER_LANDING_HEADER_ELEMENT_T,
      params: {
        language: locale,
        block: id,
      },
    });
    if (routeName.startsWith('#')) {
      return navigateHandle({ routeName });
    }

    window.open(routeName, '_blank');
  };

  if (mobileWebView) {
    return null;
  }

  return (
    <div className={cn(BLOCK_NAME)}>
      {links.map(({ routeName, title, id }) => {
        return (
          <Chips
            key={id}
            color="off-white"
            onClick={handleLinkClick(routeName, id)}
            text={translations(title)}
          />
        );
      })}
    </div>
  );
};
